export class VendorStatus {
  static PendingRequest = 1;
  static AssessmentInProgress = 2;
  static BORequestNotApproved = 3;
  static SecurityTeamApproved = 4;
  static SecurityTeamDeclined = 5;
}
